import o from "./_base.js";
const f = {
  ...o
};
export {
  f as default
};
//# sourceMappingURL=_production.js.map
